import React, { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import {
  useLazyCityViewQuery,
  useCityAddMutation,
  useCityEditMutation,
  useLazyGetStateQuery,
} from "../../redux/api/api";
import { saveLoader } from "../../redux/slice/loaderNoti";
import TopHeader from "../Dashoboard/TopHeader";

const City = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const types = location?.state?.type;

  const [name, setName] = useState("");
  const [states, setStates] = useState("");
  const [image, setImage] = useState("");
  const [nameErr, setNameErr] = useState(false);
  const [statesErr, setStatesErr] = useState(false);
  const [imageErr, setImageErr] = useState(false);
  const [btn, setBtn] = useState(false);
  const [stateList, setStateList] = useState([]);

  // RTK QUERY
  const [cityAddApi] = useCityAddMutation();
  const [cityEditApi] = useCityEditMutation();
  const [cityViewApi] = useLazyCityViewQuery();
  const [stateGetApi] = useLazyGetStateQuery();

  const submitHandler = () => {
    if (
      name?.length == 0 ||
      (types !== "edit" && image?.length == 0) ||
      states?.length == 0
    ) {
      setNameErr(true);
      setStatesErr(true);
      if (types !== "edit") {
        setImageErr(true);
      }
    } else {
      let formdata = new FormData();
      formdata.append("name", name);
      formdata.append("state_id", states);

      if (image?.name) {
        formdata.append("image", image);
      }

      if (types == "edit") {
        dispatch(saveLoader(true));
        setBtn(true);
        formdata.append("_method", "PUT");
        cityEditApi({ id: location?.state?.data?.id, payload: formdata })
          .unwrap()
          .then((res) => {
            dispatch(saveLoader(false));
            setBtn(false);
            if (res?.status == "success") {
              Swal.fire({
                text: res?.message,
                icon: "success",
              });
              navigate("/cities");
            }
          })
          .catch((err) => {
            dispatch(saveLoader(false));
            setBtn(false);
            console.log("err");
          });
      } else {
        dispatch(saveLoader(true));
        setBtn(true);
        cityAddApi(formdata)
          .unwrap()
          .then((res) => {
            dispatch(saveLoader(false));
            setBtn(false);
            if (res?.status === "success") {
              Swal.fire({
                text: res?.message,
                icon: "success",
              });
              navigate("/cities");
            }
          })
          .catch((err) => {
            dispatch(saveLoader(false));
            setBtn(false);
            console.error("Error", err);
          });
      }
    }
  };

  const getView = () => {
    dispatch(saveLoader(true));
    cityViewApi(location?.state?.data?.id)
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        if (res?.status == "success" || res?.data?.status == "success") {
          setName(res?.city?.name);
          setStates(res?.city?.state_id);
          setImage(res?.city?.image);
        }
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        console.log("err");
      });
  };

  const getState = () => {
    dispatch(saveLoader(true));
    stateGetApi()
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        if (res?.status == "success" || res?.data?.status == "success") {
          setStateList(res?.states);
        }
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        console.log("err");
      });
  };

  useEffect(() => {
    if (location?.state?.data?.id) {
      getView();
    }
    getState();
  }, []);

  return (
    <div className="dashRightView home_section">
      <TopHeader type={types == "edit" ? "edit-city" : "add-city"} />
      <div className="mt-4 block block-rounded ">
        <div className="block-content">
          <Row>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  States
                </label>
                <select
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setStates(e.target.value)}
                  value={states}
                >
                  <option value={""} disabled>
                    Select States
                  </option>
                  {stateList?.map((item, ind) => {
                    return (
                      <option value={item?.id} key={ind}>
                        {item?.name}
                      </option>
                    );
                  })}
                </select>
              </div>
              {states?.length == 0 && statesErr && (
                <p className="err">Select States</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  City Name
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setName(e.target.value)}
                  value={name}
                />
              </div>
              {name?.length == 0 && nameErr && (
                <p className="err">Enter City Name</p>
              )}
            </div>

            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  City Image (175 x 175) pixel
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setImage(e.target.files[0])}
                  type={"file"}
                  accept="image/jpeg, image/png"
                />
              </div>
              {image?.length == 0 && imageErr && (
                <p className="err">Add Image</p>
              )}
            </div>

            {image && (
              <div className="col-md-6 mb-3">
                <div className="mt-3 mx-3">
                  <img
                    src={image?.name ? URL.createObjectURL(image) : image}
                    style={{ width: "200px" }}
                  />
                </div>
              </div>
            )}
          </Row>
          <Row>
            <div className="col-md-12 text-start mx-3 mt-4 mb-4">
              <button
                className={`submit-btn f2  ${btn ? "opacity-50" : ""}`}
                onClick={() => submitHandler()}
                disabled={btn}
              >
                Save
              </button>
            </div>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default City;
